import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  count: 0,
  events: [], 
  paginatedEvents: [],
  eventLoading: false,
};

const eventSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    setCount: (state, action) => {
      state.count = action.payload;
    },
    setEvents: (state, action) => {
      state.events = action.payload;
    },
    setPaginatedEvents: (state, action) => {
      state.paginatedEvents = action.payload;
    },
    setLoading: (state, action) => {
      state.eventLoading = action.payload;
    },
  },
});

export const { setCount, setEvents, setPaginatedEvents, setLoading } = eventSlice.actions;

export default eventSlice.reducer;